import { useCookies } from 'react-cookie';

const withContrastModeManager = (WrappedComponent) => {
  return (props) => {
    const [cookies, setCookie, removeCookie] = useCookies(['contraste']);

    const toggleContrastMode = () => {
      if (cookies.contraste === 'on') {
        removeCookie('contraste');
      } else {
        setCookie('contraste', 'on');
      }
    };

    return (
      <>
        <WrappedComponent
          {...props}
          contrastModeOn={cookies.contraste === 'on'}
          toggleContrastMode={toggleContrastMode}
        />
      </>
    );
  };
};

export default withContrastModeManager;
